import isJsonString from './isJsonString';

export default class AppStorage implements Storage {
  constructor(public storage: 'local' | 'session' = 'local') {}

  public get storageName() {
    return (this.storage + 'Storage') as 'localStorage' | 'sessionStorage';
  }

  private get _storage() {
    return window[this.storageName];
  }

  get length() {
    return this._storage.length;
  }

  clear(): void {
    this._storage.clear();
  }

  key(index: number) {
    return this._storage.key(index);
  }

  removeItem(key: string) {
    this._storage.removeItem(key);
  }

  setItem<T>(key: string, value: T) {
    this._storage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: string) {
    const value = this._storage.getItem(key);

    if (!value || !isJsonString(value)) return null;

    return JSON.parse(value) as T;
  }
}
